<template>
  <aside class="alert" :class="`${variant}-light`">
    <Icon :name="icon" size="l" />
    <div>
      <header v-if="heading" class="h6" v-html="heading"></header>
      <!-- @slot In dem Slot kann flexibel der Inhalt der Alert-Box ausgestaltet werden (Text, HTML, Komponenten) -->
      <slot></slot>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import Icon from '../Icon'
import type { IconName } from '../../../types/icon'

export interface AlertProps {
  variant: 'info' | 'success' | 'warning' | 'danger'
  heading?: string,
}

const { variant, heading} = defineProps<AlertProps>()

const icon = computed<IconName>(() => {
  if (variant === 'danger'){
    return 'error-line'
  }
  return `${variant}-line`
})
</script>

<style scoped lang="scss">
@use '../../../styles' as index;

.alert {
  display: flex;
  padding: 1rem 1rem 1.33rem;
  gap: .5rem;
  border-radius: index.$size__borderRadius;
  align-items: flex-start;
}

.alert > .icon {
  flex-shrink: 0;
  padding-top: index.$size__borderRadius;
}

.alert header {
  padding-top: index.$size__borderRadius;
  font-weight: index.$typo__fontWeight--bold;
}
</style>
